import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';

import useInvitation from '@/hooks/useInvitation';
import { useImaginationRoom } from '@invitato/imagination-room';

import WithAnimation from '@/components/Common/WithAnimation';

import { THE_BRIDE } from '@/constants';
import { BG_DESKTOP_VIEW } from '@/constants/assets';

// const TEXT_SHADOW = 'rgba(12,12,12,.8)';

function LeftContent() {
  const { onGetFinalContent, onGetFinalName } = useImaginationRoom();
  const isInvitation = useInvitation();

  return (
    <Box
      bgColor="bgPrimary"
      width="calc(100% - 500px)"
      height="100%"
      pos="fixed"
      background={`linear-gradient(rgb(50 48 48/ 50%), rgb(50 48 48 / 50%)), center / cover url(${onGetFinalContent(
        'BG_DESKTOP_VIEW',
        BG_DESKTOP_VIEW,
      )})`}
      borderRight="8px solid"
      borderRightColor="blackAlpha.400"
    >
      <Box height="100%" padding="42px">
        <WithAnimation>
          <Text
            color="white"
            textColor="alternativeColorText"
            fontFamily="body_lv2"
            fontWeight="bold"
            fontSize="md"
            letterSpacing="2px"
          >
            {isInvitation ? 'THE WEDDING OF' : 'WEDDING ANNOUNCEMENT'}
          </Text>
        </WithAnimation>
        <Box
          paddingTop={'32px'}
          textColor="alternativeColorText"
          textTransform="uppercase"
          letterSpacing="4px"
        >
          <Heading
            size="4xl"
            fontFamily={'heading'}
            fontWeight="light"
            fontSize="7xl"
            textTransform="uppercase"
            dangerouslySetInnerHTML={{
              __html: onGetFinalName('coupleName', THE_BRIDE).replace('&', '&<br/>'),
            }}
          />
        </Box>
        <WithAnimation>
          <Text
            mt="24px"
            color="alternativeColorText"
            fontWeight="light"
            fontStyle="italic"
            maxWidth="800px"
            letterSpacing="1px"
          >
            "Masa lalu saya adalah milik saya, <br />
            masa lalu kamu adalah milik kamu, <br />
            tapi masa depan adalah milik kita."
            <br />- B.J. Habibie -
          </Text>
        </WithAnimation>
      </Box>
    </Box>
  );
}

export default LeftContent;
